import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-expenses',
  templateUrl: './new-expenses.component.html',
  styleUrls: ['./new-expenses.component.scss']
})
export class NewExpensesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  

}
